<template>
  <div>
    <div class="d-flex flex-row">
      <h4 class="blue--text">نوع فعالیت :</h4>
      <h4>
        {{
          isManufacturer
            ? 'صنعتگر ( سازنده صنعتی/طراح و مشاور) '
            : 'فروشنده / تاجر'
        }}
      </h4>
          <HelperComponent
                helperId="How-to-register-merchant-categories"
                class="mt-1"
              />
    </div>
    <v-form v-model="category" ref="form">
      <v-container class="my-3">
        <!-- class="w--100" -->
        <v-row>
          <v-col cols="12">
            <h4 class="mb-2 fieldset-title">
              {{ categorySelectionLabel }}
            </h4>
          </v-col>
          <v-col cols="12">
            <v-select
              label="حوزه فعالیت *"
              outlined
              persistent-hint
              item-text="displayName"
              item-value="title"
              dense
              required
              :disabled="form.isManufacturer == null || merchantIsApproved"
              return-object
              :menu-props="{
                closeOnClick: true,
                closeOnContentClick: true,
              }"
              v-model="merchantCategoryTypes"
              :items="filteredMerchantCategoryTypeItems"
              @change="getCategoriesTreeList"
              :hint="merchantCategoryTypeHint"
              class="input-box"
            />
          </v-col>
          <template v-if="activeSelectedItem">
            <v-col cols="12">
              <!--   @input="requestForResults('handleSearch', $event)"    append-icon="mdi-magnify"-->
              <v-text-field
                label="جست و جوی حوزه فعالیت *"
                outlined
                dense
                type="text"
                required
                v-model="tempSearchTree"
                hide-details
                class="input-box"
                :disabled="merchantIsApproved"
              >
                <template v-slot:append>
                  <v-btn class="mb-2" append-icon="mdi-magnify" @click="doSearchTree()"
                    >جستجو</v-btn
                  >
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="12">
              <v-card outlined>
                <v-card-title>
                  <span class="blue--text text--darken-5">{{
                    activeSelectedItem.item.displayName
                  }}</span>
                </v-card-title>
                <v-card-text>
                  <div class="treee-Category-card">
                    <v-treeview
                      open-on-click
                      ref="treeView"
                      item-text="name"
                      item-key="id"
                      item-children="subcategories"
                      :items="activeSelectedItem.treeList"
                      :search="searchTreeList"
                      color="primary"
                      transition
                      :open.sync="activeSelectedItem.openTreeItem"
                      return-object
                      hoverable
                      overflow-x-auto
                      style="width: max-content"
                      :disabled="merchantIsApproved"
                    >
                      <template v-slot:label="props">
                        <div class="treeCheckBox">
                          <v-checkbox
                            v-if="props.item.isLeaf"
                            v-model="activeSelectedItem.activeTreeItem"
                            class="mt-0"
                            hide-details
                            :value="props.item"
                            :label="props.item.name"
                            small
                            dense
                            :ripple="false"
                            @change="selectTree"
                          >
                          </v-checkbox>
                          <span v-else class="f-s-13 text-right">{{
                            props.item.name
                          }}</span>
                        </div>
                      </template>
                    </v-treeview>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </template>
        </v-row>
        <v-row ref="tables" class="mt-5" v-if="merchantCategoriesList.length">
          <v-col cols="12">
            <MerchantCategoryComponentVue
              :items="merchantCategoriesList"
              :fields="merchantCategoryFields"
              @removeFromList="removeMerchantCategoriesList"
            />
          </v-col>
        </v-row>
        <v-row> </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
const supplierProductRepository = () => RepoFactory.get('supplierProduct');
import Helper from '@/core/helpers';
const categoryRepository = () => RepoFactory.get('category');
const enumsRepository = () => RepoFactory.get('enums');
import MerchantCategoryComponentVue from './MerchantCategoryComponent.vue';
import asyncLoadMixin from '@/core/mixins/asyncLoadMixin';
export default {
  mixins: [asyncLoadMixin],
  components: {
    MerchantCategoryComponentVue,
  },
  props: {
    validateActivityCategory: {
      type: Boolean,
      default: false,
    },
    isManufacturer: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    businessRegistrationData: {
      type: Object,
      default: null,
    },
    merchantIsApproved: {
      type: Boolean,
      default: false,
    },
    merchantMonitorFields: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      tempSearchTree: null,
      category: true,
      searchTreeList: null,
      defaultOpenedTreeView: null,
      supplierProductCategoryTypes: [],
      merchantCategoryTypeItems: [],
      hasIsManufacturerInQuery: false,
      activeSelectedItem: null,
      form: {
        isManufacturer: null,
        categoryIds: [],
        categoryTypes: [],
      },
      merchantCategoryTypes: [],
      merchantCategoriesList: [],
      merchantCategoryFields: [
        {
          value: 'mainCategoryTitle',
          text: 'نوع فعالیت',
          sortable: false,
        },
        {
          value: 'breadcrumb',
          text: 'فرایند اصلی',
          sortable: false,
        },

        {
          value: 'actions',
          text: 'حذف',
          sortable: false,
        },
      ],
    };
  },
  computed: {
    merchantCategoryTypeHint() {
      if (!this.hasIsManufacturerInQuery) {
        return 'ابتدا نوع فعالیت خود را انتخاب کنید';
      }
      return '';
    },
    filteredMerchantCategoryTypeItems() {
      return this.merchantCategoryTypeItems.filter((el) =>
        this.supplierProductCategoryTypes.includes(el.title)
      );
    },
    categorySelectionLabel() {
      if (this.form.isManufacturer) {
        return ' انتخاب دسته بندی های خدمات و محصولات';
      }
      return 'انتخاب دسته بندی های کالا و تجهیزات صنعتی';
    },
  },
  watch: {
    validateActivityCategory(aft, bef) {
      if (aft) {
        if (this.$refs.form.validate()) {
          this.$emit('nextStep', this.form, 'activityCategory');
        } else {
          this.$emit('validationFailed');
        }
      }
    },
    isManufacturer(after, before) {
      this.form.isManufacturer = after;
      this.merchantCategoryTypes = [];
      this.activeSelectedItem = null;
      this.getSupplierProductCategoryTypes();
    },
    merchantCategoryTypes(after) {
      if (after.title) {
        this.getCategoriesTreeList(after);
        this.searchTreeList = '';
        this.tempSearchTree = '';
      }
    },
  },
  created() {
    this.getCategoryTypeItems();
    this.form.isManufacturer = this.isManufacturer;
    this.getSupplierProductCategoryTypes();
    this.hasIsManufacturerInQuery = true;
    if (this.isEdit && this.businessRegistrationData) {
      this.fillValue(this.businessRegistrationData);
    }
  },
  methods: {
    doSearchTree() {
      this.searchTreeList = this.tempSearchTree;
    },
    fillValue(data) {
      this.form = {
        isManufacturer: data.isManufacturer,
        categoryIds: data.merchantCategories.map((el) => {
          return el.categoryId;
        }),
        categoryTypes: data.categoryTypes,
      };
      if (data.merchantCategories && data.merchantCategories.length > 0) {
        this.$emit('setValidateActivityCategory',true);
        
      }
    },
    findDispalyName(type) {
      const statusObj = this.filteredMerchantCategoryTypeItems.find(
        (el) => el.title === type
      );
      if (statusObj) return statusObj.displayName;
      return '';
    },
    removeMerchantCategoriesList(item) {
      
      // step:1 remove from merchant categories list
      this.merchantCategoriesList = this.merchantCategoriesList.filter(
        (el) => el.categoryId !== item.categoryId
      );
      this.form.categoryIds = this.form.categoryIds.filter(
        (el) => el !== item.categoryId
      );
      
      if (this.form.categoryIds.length == 0) {
        this.$emit('setValidateActivityCategory',false);
       // this.$emit('validationFailed');
        
      }
      // step:2 remove from selected tree items
      this.activeSelectedItem.activeTreeItem =
        this.activeSelectedItem.activeTreeItem.filter(
          (el) => el.id != item.categoryId
        );
      // step:3 remove from categoryTypes if removed merchant
      // category is not exist in categoryTypes
      const categoryTypeTitle = item.categoryTypeTitle;
      if (
        !this.merchantCategoriesList.find(
          (el) => el.categoryTypeTitle == categoryTypeTitle
        )
      ) {
        this.form.categoryTypes.forEach((x, i) => {
          if (x == item.categoryTypeItem) {
            this.form.categoryTypes.splice(i, 1);
            return;
          }
        });
        this.merchantCategoryTypes.splice(
          this.form.categoryTypes.indexOf(
            (el) => el.title == categoryTypeTitle
          ),
          1
        );
      }
    },
    getCategoriesTreeList(val) {
      const loader = this.$loading.show();
      const param = {};
      param.categoryTypes = val.title;

      categoryRepository()
        .getCategoriesListMenu(this.$store.getters.productBaseUrl, param)
        .then((res) => {
          const data = {
            item: val,
            treeList: res.data,
            activeTreeItem: [],
            openTreeItem: res.data,
          };
          this.activeSelectedItem = data;
          this.defaultOpenedTreeView = data.openTreeItem;
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          Helper.handleErrors(error, this);
        });
    },
    handleSearch(val) {
      if (val) {
        this.$refs.treeView.updateAll(true);
      } else {
        this.$refs.treeView.updateAll(false);
        this.activeSelectedItem.openTreeItem = this.defaultOpenedTreeView;
      }
    },
    getCategoryTypeItems() {
      return new Promise((resolve, reject) => {
        enumsRepository()
          .getEnum('CategoryTypeItems', this.$store.getters.productBaseUrl)
          .then(({ data }) => {
            this.merchantCategoryTypeItems = data;
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getSupplierProductCategoryTypes() {
      return new Promise((resolve, reject) => {
        const params = {
          supplierIsManufacturer: this.form.isManufacturer,
        };
        supplierProductRepository()
          .getSupplierProductCategoryTypes(
            this.$store.getters.productBaseUrl,
            params
          )
          .then(({ data }) => {
            this.supplierProductCategoryTypes = data;
            if (this.isEdit) {
              if (this.businessRegistrationData.categoryTypes.length) {
                this.businessRegistrationData.categoryTypes.forEach(
                  (element) => {
                    this.merchantCategoryTypes = {
                      title: element,
                      displayName: this.findDispalyName(element),
                    };
                  }
                );
                this.merchantCategoriesList =
                  this.businessRegistrationData.merchantCategories;
                if (this.merchantCategoriesList.length > 0) {
                  this.getMerchantCategoriesByIds();
                }
              }
            }
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    selectTree(val) {
      if (val && val.length) {
        this.getMerchantCategoriesByIds();
      } else {
        this.merchantCategoriesList = [];
        this.form.categoryIds = [];
      }
    },
    getMerchantCategoriesByIds() {
      let ids = [];
      if (this.activeSelectedItem?.activeTreeItem.length > 0) {
        this.activeSelectedItem.activeTreeItem.forEach((element) => {
          ids.push(element.id);
        });
       this.$emit('setValidateActivityCategory',true);
        
      }
      if (
        this.form.categoryIds == undefined ||
        this.form.categoryIds == null ||
        this.form.categoryIds == ''
      ) {
        this.form.categoryIds = [];
      }
      this.form.categoryIds = this.form.categoryIds.concat(ids);
      this.form.categoryIds = Array.from(new Set(this.form.categoryIds));

      const params = {
        ids: this.form.categoryIds.join(','),
      };
      const loader = this.$loading.show();
      categoryRepository()
        .getMerchantCategoriesByIds(this.$store.getters.productBaseUrl, params)
        .then((res) => {
          let ids = [];
          this.merchantCategoriesList.forEach((x) => {
            ids.push(x.categoryId);
          });
          res.data.forEach((x) => {
            if (!ids.includes(x.categoryId)) {
              this.merchantCategoriesList.push(x);
            }
          });
          if (this.activeSelectedItem?.activeTreeItem.length) {
            this.activeSelectedItem.activeTreeItem.forEach((el) => {
              if (!this.form.categoryTypes.includes(el.categoryType)) {
                this.form.categoryTypes.push(el.categoryType);
              }
            });
          }

          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          Helper.handleErrors(error, this);
        });
    },
    deSelectTree() {
      this.selectionItems.forEach((element) => {
        element.activeTreeItem = [];
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.treee-Category-card {
  max-height: 300px !important;
  overflow: auto;
}
.input-box {
  max-width: 300px !important;
}
</style>
